import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { getFeatureFlag } from "~/config/tenant-config";
import { IS_DEV } from "~/consts/env";
import { RUM_DATAPLANE_ENDPOINT } from "~/consts/rum";

let awsRum: AwsRum | null = null;

export function initRum(AppID: string) {
  if (awsRum) return awsRum;
  if (IS_DEV) return null;

  try {
    const useProxy = getFeatureFlag((config) => config.features.rumProxyEnabled);

    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      endpoint: useProxy
        ? `${window.location.origin}/api/rum-ingest`
        : RUM_DATAPLANE_ENDPOINT,
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: false,
      signing: false,
      batchLimit: 25,
      useBeacon: true,
      sessionAttributes: {
        env: process.env.NEXT_PUBLIC_ENV ?? '',
        customer: process.env.NEXT_PUBLIC_CUSTOMER ?? '',
      },
    };

    const APPLICATION_ID = AppID;
    const APPLICATION_VERSION = "1.15.0";
    const APPLICATION_REGION = "us-east-1";

    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );

    return awsRum;
  } catch (error) {
    console.error("RUM init failed", error);
    return null;
  }
}

export function getRum() {
  return awsRum;
}
